import { render, staticRenderFns } from "./viewCars.vue?vue&type=template&id=236f5e52&"
import script from "./viewCars.vue?vue&type=script&lang=js&"
export * from "./viewCars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports